import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgNew(props: RootSvgProps) {
  return (
    <RootSvg
      width="36"
      height="19"
      viewBox="0 0 36 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        y="0.5"
        width="36"
        height="18"
        rx="4"
        fill="url(#paint0_linear_122_7251)"
      />
      <path
        d="M13.7051 4.96875V13.5H11.9473L8.51953 7.78125V13.5H6.76172V4.96875H8.51953L11.9531 10.6934V4.96875H13.7051ZM18.0469 13.6172C17.5547 13.6172 17.1133 13.5391 16.7227 13.3828C16.332 13.2227 16 13.002 15.7266 12.7207C15.457 12.4395 15.25 12.1133 15.1055 11.7422C14.9609 11.3672 14.8887 10.9688 14.8887 10.5469V10.3125C14.8887 9.83203 14.957 9.39258 15.0938 8.99414C15.2305 8.5957 15.4258 8.25 15.6797 7.95703C15.9375 7.66406 16.25 7.43945 16.6172 7.2832C16.9844 7.12305 17.3984 7.04297 17.8594 7.04297C18.3086 7.04297 18.707 7.11719 19.0547 7.26562C19.4023 7.41406 19.6934 7.625 19.9277 7.89844C20.166 8.17188 20.3457 8.5 20.4668 8.88281C20.5879 9.26172 20.6484 9.68359 20.6484 10.1484V10.8516H15.6094V9.72656H18.9902V9.59766C18.9902 9.36328 18.9473 9.1543 18.8613 8.9707C18.7793 8.7832 18.6543 8.63477 18.4863 8.52539C18.3184 8.41602 18.1035 8.36133 17.8418 8.36133C17.6191 8.36133 17.4277 8.41016 17.2676 8.50781C17.1074 8.60547 16.9766 8.74219 16.875 8.91797C16.7773 9.09375 16.7031 9.30078 16.6523 9.53906C16.6055 9.77344 16.582 10.0312 16.582 10.3125V10.5469C16.582 10.8008 16.6172 11.0352 16.6875 11.25C16.7617 11.4648 16.8652 11.6504 16.998 11.8066C17.1348 11.9629 17.2988 12.084 17.4902 12.1699C17.6855 12.2559 17.9062 12.2988 18.1523 12.2988C18.457 12.2988 18.7402 12.2402 19.002 12.123C19.2676 12.002 19.4961 11.8203 19.6875 11.5781L20.5078 12.4688C20.375 12.6602 20.1934 12.8438 19.9629 13.0195C19.7363 13.1953 19.4629 13.3398 19.1426 13.4531C18.8223 13.5625 18.457 13.6172 18.0469 13.6172ZM23.4199 11.8594L24.7383 7.16016H25.8105L25.4648 9.00586L24.1465 13.5H23.25L23.4199 11.8594ZM22.752 7.16016L23.6953 11.8535L23.7832 13.5H22.7285L21.123 7.16016H22.752ZM27.0176 11.7773L27.9375 7.16016H29.5723L27.9668 13.5H26.918L27.0176 11.7773ZM25.957 7.16016L27.2695 11.8242L27.4512 13.5H26.5488L25.2305 9.01172L24.8965 7.16016H25.957Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_122_7251"
          x1="0"
          y1="0.5"
          x2="36"
          y2="0.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#164081" />
          <stop offset="1" stopColor="#3F73D3" />
        </linearGradient>
      </defs>
    </RootSvg>
  );
}
